import { css } from 'emotion'

export const ReportMainStyles = css`
  h6 {
    margin-bottom: 16px;
    text-transform: capitalize;
  }
`
